/**
 * --------------------------------------------------
 * components/ShopLocalization.ts
 *
 * - Support multiple markets, currencies and languages
 * - Dependencies: Shopify Markets & Geolocation App
    - https://help.shopify.com/en/manual/markets
    - https://apps.shopify.com/geolocation
 * --------------------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import Search from 'iso-country-currency';
import 'currency-flags/dist/currency-flags.css';

@Component
export class ShopLocalization extends ThemeComponent {
    @Ref({required: false}) flag!: HTMLSpanElement;
    @Ref select!: HTMLSelectElement;

    init() {
        this.addEventListeners();
        this.handleFlag();
    }

    private addEventListeners() {
        this.$listen(this.select, 'change', () => {
            this.select.closest('form')?.submit();
        });
    }

    private handleFlag() {
        if (!this.flag) { return; }
        const currency:string|undefined = this.flag.dataset.currency;
        if (!currency) { return;}

        this.flag.classList.add(`currency-flag-${currency.toLowerCase()}`, 'is-active');
    }
}
